export enum ComplaintStatus {
    Discarted = -1,
    Pending = 0,
    Aproved = 1
}
